import React from 'react';
import { replace } from 'react-router-redux';

import {ROUTE_CLUB, ROUTE_NIGHT_TIMES} from '../../../constants/routeconstants';
import { connect } from 'react-redux';
import UserRoles from "../../../../../common/src/enums/UserRoles";
import {Link} from "react-router";
import * as AdminActions from "../../../actions/admin";
import {confirm} from "../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import UserFieldDataType from "../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from "../../reusable/UserFieldElement";
import moment from "moment";
import config from "../../../../../server/src/config";

class NightTimesPage extends React.Component {

    static getId() {
        return ROUTE_NIGHT_TIMES;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            editId: null,
            sortField: 'no',
        };
    }

    componentDidMount() {
        this.props.dispatch(AdminActions.getListItems('nattid'));
    }

    fields = [];
    render() {
        return this.props.nightTimes ? <div>
            <div className="sub-page-title">
                <h2>Nattider</h2>
            </div>
            <div id="sub-page-content" className="sub-page-content">
                <table className="data-table">
                    <thead>
                    <tr>
                        <th scope="row" className="clickable" onClick={() => {this.setState({sortField: 'no'})}}>Uge</th>
                        <th className="clickable" onClick={() => {this.setState({sortField: 'zip'})}}>Start</th>
                        <th>Slut</th>
                        <th>Afsluttet</th>
                        <th className="commands-column"></th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.nightTimes.sort((s1, s2) => {
                        if (s1.Uge === '') return 1;
                        if (s2.Uge === '') return -1;
                        return this.state.sortField === 'no' ? (s1.Uge < s2.Uge ? -1 : 1) : s1.Start.toString().localeCompare(s2.Start.toString(), 'da-DK')
                    }).toArray().concat(this.state.editId === 'new' ? [this.state] : []).map(nightTime => {
                        return this.state.editId === null || (nightTime.Uge !== this.state.editId && typeof(nightTime.editId) === 'undefined') ? <tr key={nightTime.Uge} id={'row-' + nightTime.Uge}>
                            <th scope="row">{nightTime.Uge}</th>
                            <td>{nightTime.Start}</td>
                            <td>{nightTime.Slut}</td>
                            <td>{nightTime.Afsluttet ? 'Ja': 'Nej'}</td>
                            <td className="commands-column">
                                <i className={"fa fa-pencil " + (this.state.editId === null ? 'clickable' : 'disabled')} title="Rediger nattid" onClick={() => {
                                    if (this.state.editId === null) this.setState({
                                        editId: nightTime.Uge,
                                        Uge: nightTime.Uge,
                                        Start: nightTime.Start === null ? '' : nightTime.Start,
                                        Slut: nightTime.Slut === null ? '' : nightTime.Slut,
                                        Afsluttet: nightTime.Afsluttet === null ? '' : nightTime.Afsluttet,
                                    });
                                }}/>
                                <i className={"fa fa-trash " + (this.state.editId === null ? 'clickable' : 'disabled')} title="Slet nattid" onClick={() => {
                                    if (this.state.editId === null) confirm("Slet", <span>Ønsker du at slette nattiden for uge <b>{nightTime.Uge}</b>?</span>, () => {
                                        this.props.dispatch(AdminActions.deleteListItem('nattid', nightTime.Uge, () => {
                                            NotificationManager.success(`Nattiden for uge ${nightTime.Uge} er slettet.`, "Sletning", 4000);;
                                        }));
                                    });
                                }}/>
                            </td>
                        </tr> : <tr key="editor" id="row-editor" className="edit-row">
                            <th>
                                <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                  name="Uge" id="Uge" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.Uge.toString()}
                                                  autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                    //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-130px', zIndex: 99999}}}
                                                  onChange={this.onStandardFieldChange}
                                                  ref={instance => { this.fields[0] = instance; }}
                                />
                            </th>
                            <td>
                                <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="" containerClassName="display-inline-block"
                                                  name="Start" id="Start" maxLength="4" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3,4}"}]} value={this.state.Start.toString()}
                                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  onChange={this.onStandardFieldChange}
                                                  ref={instance => { this.fields[1] = instance; }}
                                />
                            </td>
                            <td>
                                <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="" containerClassName="display-inline-block"
                                                  name="Slut" id="Slut" maxLength="4" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3,4}"}]} value={this.state.Slut.toString()}
                                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  onChange={this.onStandardFieldChange}
                                                  ref={instance => { this.fields[2] = instance; }}
                                />
                            </td>
                            <td>
                                <UserFieldElement dataType={UserFieldDataType.enum} placeholder={false} className="" containerClassName="display-inline-block"
                                                  name="Afsluttet" id="Afsluttet" options={[{key:"Ja",value:"Ja"}, {key:"Nej",value:"Nej"}]} defaultValue={Number(nightTime.Afsluttet) ? 'Ja': 'Nej'}
                                                  autoCheckErrors={false} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  onChange={this.onStandardFieldChange}
                                                  ref={instance => { this.fields[3] = instance; }}
                                />
                            </td>
                            <td className="commands-column">
                                <i className="fa fa-save clickable" title="Gem nattid" onClick={() => {
                                    this.save();
                                }}/>
                                <i className="fa fa-undo clickable" title="Annuller" onClick={() => {
                                    this.setState({editId: null});
                                }}/>
                            </td>
                        </tr>
                    })}
                    </tbody>
                </table>
            </div>
            <div className="sub-page-actions">
                <button className={"btn-primary" + (this.state.editId === null ? '' : ' disabled')} title="Opret ny nattid" onClick = {() => {
                    if (this.state.editId === null) {
                        this.setState({
                            editId: 'new',
                            Uge: '',
                            Start: '',
                            Slut: '',
                            Afsluttet: 0,
                        });
                        setTimeout(function () {
                            const content = document.getElementById("sub-page-content");
                            content.scrollTop = content.scrollHeight;
                        });
                    }
                }}>Ny</button>
            </div>
        </div> : null;
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    save = () => {
        if (this.allInputValid()) {
            const Uge = this.state.Uge;
            const entity = {
                Uge: Number(this.state.Uge),
                Start: this.state.Start === '' ? null : Number(this.state.Start),
                Slut: this.state.Slut === '' ? null : Number(this.state.Slut),
                Afsluttet: this.state.Afsluttet === '' ? null : this.state.Afsluttet === "Ja" ? true: false,
            };
            if (this.state.editId === 'new') this.props.dispatch(AdminActions.createListItemItem('nattid', entity, id => {
                NotificationManager.success(`Nattiden for uge ${id} er oprettet.`, "Oprettelse", 4000);
                this.setState({editId: null});
                setTimeout(function () {
                    const currentRow = document.getElementById("row-" + Uge);
                    currentRow.scrollIntoView(false);
                });
            }));
            else this.props.dispatch(AdminActions.updateListItem('nattid', this.state.editId, entity, id => {
                NotificationManager.success(`Nattiden for uge ${id} er oprettet.`, "Opdatering", 4000);
                this.setState({editId: null});
                setTimeout(function () {
                    const currentRow = document.getElementById("row-" + Uge);
                    currentRow.scrollIntoView(false);
                });
            }));
        }  else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const mapStateToProps = (state) => ({
    nightTimes: state.admin.nightTimes,
});

export default connect(mapStateToProps)(NightTimesPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/lists/NightTimesPage.js